import { IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import styled from "styled-components";

const OuterContainer = styled.div`
    min-height: 6em;
`;

const Header = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const Splitter = styled.div`
    height: 3px;
    background: #999;
    width: 75px;

    &.done {
        background: #56a44f;
    }
`;

const Step = styled.div`
    width: 55px;
    height: 55px;
    position: relative;
    border-radius: 50%;
    color: #666;
    border: 3px solid #999;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    font-size: 1.1em;
    /* 
    &.busy {
        color: #56a44f;
        border: 3px solid #56a44f;
    } */

    &.done {
        background: #56a44f;
        border: 3px solid transparent;
        color: white;
    }
`;

const StepText = styled.p`
    position: absolute;
    white-space: nowrap;
    color: #666;
    top: 3.4em;
`;

const Icon = styled(FontAwesomeIcon)`
    /* position: absolute; */
    /* left: 0.5em; */
    margin: 0.2em;
    font-size: 1.2em;
`;

export type StepsProps = {
    steps: {
        name: string;
        icon: IconDefinition;
        hidden?: boolean;
    }[];
    currentIndex: number;
    doneIcon?: IconDefinition;
};

export function Steps(props: StepsProps) {
    return (
        <OuterContainer>
            <Header>
                {props.steps.map(
                    (e, i) =>
                        !e.hidden && (
                            <React.Fragment key={i}>
                                {i > 0 && <Splitter className={i <= props.currentIndex ? "done" : ""} />}
                                <Step className={i <= props.currentIndex ? "done" : ""}>
                                    <Icon icon={props.doneIcon && i < props.currentIndex ? props.doneIcon : e.icon} />
                                    <StepText>{e.name}</StepText>
                                </Step>
                            </React.Fragment>
                        )
                )}
            </Header>
        </OuterContainer>
    );
}
